"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _NewsItem = require("@quixeltools/quixel-ui-library/dist/components/common/blog/NewsItem");

var _NewsItem2 = _interopRequireDefault(_NewsItem);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NextPrev(_ref) {
  var _ref$item = _ref.item,
      date = _ref$item.date,
      slug = _ref$item.slug,
      title = _ref$item.title,
      image = _ref$item.image;

  var dateObj = new Date(date);
  var _ref2 = [dateObj.getFullYear(), dateObj.getMonth() + 1, dateObj.getDate()],
      year = _ref2[0],
      month = _ref2[1],
      dateStr = _ref2[2];

  var link = "/blog/" + year + "/" + month + "/" + dateStr + "/" + slug;

  return _react2.default.createElement(_NewsItem2.default, {
    isHome: true,
    title: title,
    date: (0, _utils.prettyDate)(date),
    bg: image,
    to: link
  });
}

exports.default = NextPrev;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Blog/Articles.NextPrev.jsx
// module id = 2983
// module chunks = 0